import PeopleIcon from '@mui/icons-material/People';
import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { StyledProjectChip } from './styles';
import { buildPath, PRIVATE_ROUTE } from '../../../routes/routes';
import { getInitials } from '../../../utils/utils';
import Image from '../../elements/image/Image';
import Text from '../../elements/text/Text';

const ProjectListItem = ({ project }) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ListItem>
      <ListItemAvatar>
        <Image
          size="small"
          shape="rounded"
          alt={project.name}
          src={project?.icon}
        >
          {getInitials(project.name)}
        </Image>
      </ListItemAvatar>

      <ListItemText
        primary={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link
              component={RouterLink}
              to={buildPath({
                path: PRIVATE_ROUTE.PROJECT_OVERVIEW,
                params: { projectId: project.id },
              })}
              color="inherit"
              underline="hover"
            >
              {project.name}
            </Link>
            {project.role && (
              <StyledProjectChip
                aria-label="user role"
                label={project.role}
                size="small"
                variant="outlined"
              />
            )}
          </Box>
        }
        secondary={
          isSmallScreen && (
            <Text caption aria-label="members">
              {t('memberCount', { ns: 'project', count: project.memberCount })}
            </Text>
          )
        }
      />

      {!isSmallScreen && (
        <ListItemSecondaryAction>
          <Box sx={{ display: 'flex' }}>
            <PeopleIcon />
            <Text aria-label="members">{project.memberCount}</Text>
          </Box>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};

ProjectListItem.propTypes = {
  project: PropTypes.object.isRequired,
};

export default ProjectListItem;
